// @flow
import { useMemo } from 'react';
import { useMutation } from 'react-query';
import ResidentService from '../../../../../services/residentService';

import type { MutationOptions } from 'react-query';
import type { PetMutationResponse, PetPayloadItem } from '../../types';

/** Sends resident-pet mutations without UI side effects. */
const useHouseholdPetMutation = ({
  organizationId,
  propertyId,
  residentId,
  options,
}: {
  organizationId: string,
  propertyId: string,
  residentId: ?string,
  options?: MutationOptions,
}) => {
  const residentService = useMemo(() => new ResidentService(), []);
  const mutationResidentId = residentId ?? '';

  return useMutation(
    (payload: Array<PetPayloadItem>): Promise<PetMutationResponse> =>
      residentService.editResidentHousehold(
        mutationResidentId,
        payload,
        organizationId,
        propertyId,
      ),
    options,
  );
};

export default useHouseholdPetMutation;
